export const saveToken = (token) => {
    localStorage.setItem('Accesstoken', token);
    localStorage.setItem('token_saved_at', Date.now().toString());
};

export const getToken = () => {
    return localStorage.getItem('Accesstoken');
};

export const removeToken = () => {
    localStorage.removeItem('Accesstoken');
    localStorage.removeItem('token_saved_at');
};

// Enhanced logout function that clears permissions
export const logout = (dispatch) => {
    removeToken();
    // Clear permissions from Redux store
    if (dispatch) {
        const { clearPermissions } = require('../../redux/permissionSlice2');
        const { setToken } = require('../../redux/tokenslice');
        dispatch(clearPermissions());
        dispatch(setToken(null));
    }
};
